// source: pbtypes/gen/scan_planner/single_column_inspection_scan_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
goog.exportSymbol('proto.scan_planner.SingleColumnInspectionScanRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.SingleColumnInspectionScanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.SingleColumnInspectionScanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.SingleColumnInspectionScanRequest.displayName = 'proto.scan_planner.SingleColumnInspectionScanRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.SingleColumnInspectionScanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.SingleColumnInspectionScanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.SingleColumnInspectionScanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
columnPositionXy: (f = msg.getColumnPositionXy()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f),
gimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
overlap: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
takePhoto: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.SingleColumnInspectionScanRequest}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.SingleColumnInspectionScanRequest;
  return proto.scan_planner.SingleColumnInspectionScanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.SingleColumnInspectionScanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.SingleColumnInspectionScanRequest}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setColumnPositionXy(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitch(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setOverlap(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTakePhoto(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.SingleColumnInspectionScanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.SingleColumnInspectionScanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.SingleColumnInspectionScanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColumnPositionXy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
  f = message.getGimbalPitch();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getOverlap();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getTakePhoto();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional eigen_lcm.Vector2dPb column_position_xy = 1;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.getColumnPositionXy = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 1));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.scan_planner.SingleColumnInspectionScanRequest} returns this
*/
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.setColumnPositionXy = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.SingleColumnInspectionScanRequest} returns this
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.clearColumnPositionXy = function() {
  return this.setColumnPositionXy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.hasColumnPositionXy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float gimbal_pitch = 2;
 * @return {number}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.getGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.SingleColumnInspectionScanRequest} returns this
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.setGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float overlap = 3;
 * @return {number}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.getOverlap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.SingleColumnInspectionScanRequest} returns this
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.setOverlap = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional bool take_photo = 4;
 * @return {boolean}
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.getTakePhoto = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.SingleColumnInspectionScanRequest} returns this
 */
proto.scan_planner.SingleColumnInspectionScanRequest.prototype.setTakePhoto = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


goog.object.extend(exports, proto.scan_planner);
